import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "adapt-call-to-action-inline",
    templateUrl: "./call-to-action-inline.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CallToActionInlineComponent {
    @Input() public featureUrl?: string;
}
